import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SharedModule } from '../../shared.module';
import { TranslocoModule } from '@ngneat/transloco';
import { PowerPlant } from '../solar-calculation-result/model/power-plant';
import { ResultListValueField } from '../solar-calculation-result/model/result-list-value-field';

@Component({
  selector: 'psc-basic-power-plant-info',
  standalone: true,
  imports: [CommonModule, SharedModule, TranslocoModule, NgOptimizedImage],
  templateUrl: './basic-power-plant-info.component.html'
})
export class BasicPowerPlantInfoComponent implements OnChanges {
  @Input() powerPlant: PowerPlant;

  valuesList: ResultListValueField[];

  ngOnChanges() {
    this.valuesList = [
      {
        labelKey: 'country',
        stringValue: this.powerPlant.price.country,
        unit: '',
      },
      {
        labelKey: 'contractor',
        stringValue: this.powerPlant.price.name,
        unit: '',
      },
      {
        labelKey: 'tariff_model',
        stringValue: this.powerPlant.price.tariffModel,
        unit: '',
      },
      {
        labelKey: 'typeCalculation',
        stringValue: this.powerPlant.analysisRequest.typeCalculation,
        unit: '',
        translatePrefix: 'home.calculator.type_calculation.values.',
      },
      {
        labelKey: 'tilt',
        value: this.powerPlant.tilt,
        unit: '',
      },
      {
        labelKey: 'azimuth',
        value: this.powerPlant.azimuth,
        unit: '°',
      },
      {
        labelKey: 'area',
        value: this.powerPlant.area,
        unit: 'm2',
      },
      {
        labelKey: 'investment',
        value: this.powerPlant.analysisResponse.investmentCostPerKw,
        unit: `${this.powerPlant.price.currency}/kW`,
      },
    ];
  }

}
